import { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { QueturePlayer } from '@quebon/shared-learning'
import type { QuetureApiInterface } from '@quebon/shared-learning'
import { reviewVideos } from './reviewsData'
import playWhite from '@/assets/reviews/icon-play-white.svg'

export default function ReviewVideoSection() {
  const { t } = useTranslation('common')
  const [urlIndex, setUrlIndex] = useState(0)
  const current = reviewVideos[urlIndex]

  const quetureApi = useMemo<QuetureApiInterface>(
    () => ({
      getQuetureInfo: async () => {
        throw new Error(
          'Direct hlsUrl used; getQuetureInfo should not be called',
        )
      },
    }),
    [],
  )

  return (
    <section id="review-videos" data-marketing-section="" className="bg-white pt-12 pb-10 md:pt-[100px] md:pb-20">
      <p className="text-center text-[28px] md:text-[40px] font-bold leading-[1.4] tracking-[-0.6px]">
        <span className="md:hidden whitespace-pre-line">
          {'놀라운 변화를 담은\n생생한 이야기를 통해'}
        </span>
        <span className="hidden md:inline">
          {t('reviews.video.sectionSub')}
        </span>
        <br />
        <span className="text-[#4599ff]">
          <span className="md:hidden whitespace-pre-line">
            {'깨봉수학의\n진정한 힘을 느껴보세요!'}
          </span>
          <span className="hidden md:inline">
            {t('reviews.video.sectionTitleEmphasis')}
          </span>
        </span>
      </p>

      <div
        data-testid="text-image-split"
        className="
          max-w-[1180px] mx-auto mt-10 md:mt-20 pb-0 md:pb-12 px-5 lg:px-0
          flex flex-col lg:flex-row items-center gap-6 lg:gap-10
        "
      >
        <div
          className="
            lc-video-wrapper
            w-full lg:w-[564px] aspect-video
            border-[8px] border-[#505050] rounded-[24px]
            overflow-hidden shrink-0 relative bg-[#505050]
            shadow-[0_8px_20px_0_#babad3]
          "
        >
          <QueturePlayer
        renderMetadataMath
            key={current.url}
            qid={String(current.reviewIndex)}
            hlsUrl={current.url}
            thumbnailUrl={current.thumbnail}
            quetureApi={quetureApi}
            allowSkip
          />
        </div>

        <div className="relative w-full lg:min-w-0 md:h-[311px] h-[311px]">
          <ul className="flex flex-col gap-4 h-full overflow-y-scroll px-2 md:px-4 pb-10">
            {reviewVideos.map((video, index) => {
              const isSelected = index === urlIndex
              return (
                <li
                  key={video.url}
                  onClick={() => setUrlIndex(index)}
                  className={`
                    w-full flex items-center gap-4 md:gap-6 p-4 md:p-6
                    h-[112px] rounded-[24px] bg-white cursor-pointer
                    shadow-[0_4px_16px_0_#dadaf1]
                    ${isSelected ? 'border-2 border-[#4599ff]' : ''}
                  `}
                >
                  <div
                    className={`
                      shrink-0 rounded-full flex items-center justify-center font-bold relative
                      w-6 h-6 text-[11px] md:w-10 md:h-10 md:text-[18px]
                      ${
                        isSelected
                          ? 'bg-[#4599ff] text-transparent'
                          : 'bg-[#f0f0f0] text-[#d0d0d0]'
                      }
                    `}
                  >
                    {isSelected ? (
                      <img
                        src={playWhite}
                        alt=""
                        className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-3 h-3 md:w-5 md:h-5"
                      />
                    ) : (
                      index + 1
                    )}
                  </div>
                  <div className="w-full min-w-0">
                    <p className="text-[14px] md:text-[16px] text-[#131313] truncate">
                      {video.name}
                    </p>
                    <p className="text-[16px] md:text-[20px] text-[#333] font-bold truncate">
                      {video.comment}
                    </p>
                  </div>
                  <div className="w-[88px] h-16 shrink-0 ml-auto">
                    <img
                      src={video.thumbnail}
                      alt={video.name}
                      className="w-full h-full object-cover rounded-lg"
                    />
                  </div>
                </li>
              )
            })}
          </ul>
          <div
            aria-hidden
            className="absolute left-0 bottom-0 w-full h-6 pointer-events-none"
            style={{
              background:
                'linear-gradient(0deg, #fff 33%, rgba(255,255,255,0) 92%)',
            }}
          />
        </div>
      </div>
    </section>
  )
}
